module.exports = __webpack_public_path__ + "img/doubleSideRectangularTrapezoidVertical.90c23aaf.svg";